module.exports = __webpack_public_path__ + "static/media/silfa.ad9014c4.png";